import utils from '@/utils/common'
import { isWeChatApplet } from "@/utils/util";

const doRealJump = async (item)=>{
  let linkType = item.pageLinkType
  let linkValue = item.pageLinkValue
  let goodsId = item.goodsId // 跳转店铺或品牌将此商品置顶
  let origin = window.location.origin + '/h5user'
  let finishPage =  item.use === 'redirectTo' ? 1 : undefined // finishPage为1时关闭当前页面再跳转
  let goUrl, miniUrl, action = '';

  if(linkType == 4){
    goUrl = origin + '/brandindex?id=' + linkValue + (goodsId ? `&goodsId=${goodsId}` : '');
    miniUrl = '/product/pages/store-detail/index?storeid=' + linkValue;
    action= { tm: 4090100, tp: { branchId: Math.floor(linkValue), goodsId } };
  }

  if(await isWeChatApplet()) {
    utils.jumpToNewPage({
      url: goUrl,
      action: action,
      finishPage,
    })
  } else {
    finishPage ? wx.miniProgram.redirectTo({url: miniUrl}) : wx.miniProgram.navigateTo({ url: miniUrl })
  }
}

export function navigateTo(vm, item) {
  let linkType = item.pageLinkType
  let linkValue = item.pageLinkValue
  let goodsId = item.goodsId // 跳转店铺或品牌将此商品置顶
  let origin = window.location.origin + '/h5user'
  let realTenantId = item.realTenantId
  let branchId = item.branchId
  let finishPage =  item.use === 'redirectTo' ? 1 : undefined // finishPage为1时关闭当前页面再跳转
  let url, noTitle = 1;
  
  //使用Math.floor取整，是因为ios那边需要number类型
  switch(linkType) {
    case 1: // 不跳转
      return;
    case 2: // 链接
      utils.jumpToNewPage({
        url: linkValue,
        finishPage
      })
      break;
    case 3: // 商品详情
      utils.jumpToNewPage({
        url: origin + '/newcommoditydetails?id=' + linkValue,
        action: { tm: '4030100', tp: { goodsId: Math.floor(linkValue),realTenantId,branchId} },
        finishPage,
      })
      break;
    case 4: // 店铺首页
      doRealJump(item)
      break;
    case 6: //我的蜜蜂
      utils.jumpBeeLists()
      break; 
    case 9: //品牌分类列表
      url = '/strollbrand'
      utils.nativeMethod({ tm: 4070200, tp: {} })
      break;
    case 10: //品牌首页
      url = '/brandlist?id=' + linkValue + (goodsId ? `&goodsId=${goodsId}` : '')
      const id = Math.floor(linkValue)
      const tp = window.tools.isAndroid() ? { logoId: id } : { brandId: id }
      tp.goodsId = goodsId
      utils.nativeMethod({ tm: 4070100, tp })
      break;
    case 11: //二级页面
      utils.jumpToNewPage({
        url: origin + '/activity?id=' + linkValue,
        finishPage,
      })
      break;
    case 12: //首页
      utils.goPageByName({ id: 'index', name: '首页' })
      break;
    case 13: //优惠券列表 
      utils.jumpToNewPage({
        url: origin + '/myCoupon',
        finishPage,
      })
      break;  
    case 14: //小程序路径
      utils.nativeMethod({ tm: 4000104, tp: { path: linkValue } })
      break;
    case 51: //icon商品分类
      utils.jumpToNewPage({
        url: origin + '/iconDetail?iconid=' + item.id,
        finishPage,
      })
      break;
    case 52: //跳转商场
      utils.jumpToNewPage({
        url: origin + '/markentindex?id=' + linkValue,
        finishPage,
      })
      break; 
    case 53: //商品落地页
      utils.jumpToNewPage({
        url: origin + '/landingPage?type=goods&goodsIdList=' + linkValue,
        finishPage
      })
      break;
    case 54: //店铺落地页
      utils.jumpToNewPage({
        url: origin + '/landingPage?type=store&branchId=' + linkValue,
        finishPage
      })
      break; 
  }
  if(process.env.NODE_ENV !== 'production' && url) {
    utils.jumpToNewPage({
      url: origin + url,
      finishPage
    })
  }
  if(isApp == 'unionpay' && url){
    utils.jumpToNewPage({
      url: origin + url,
      finishPage
    })
  }
}
